import { cva } from 'class-variance-authority'

export const illustrationVariants = cva('inline-block shrink-0', {
  variants: {
    size: {
      big: 'size-[80px]',
      medium: 'size-[48px]',
      small: 'size-[40px]',
    },
  },
  defaultVariants: {
    size: 'big',
  },
})
